import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';

import { Settings } from '../../ui/icon/Settings';
import { Slideout } from '../../ui/view/Slideout';

import './fair-interactive-map-filter-bar.css';

function FairInteractiveMapFilterBar({
  numberOfResults,
  selectedCategories,
  setValue,
  clearValues,
  renderFilterList,
  renderFloorSelector,
  renderSearchBox,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const handleSidebarOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleSidebarClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  useEffect(() => {
    document.body.classList.add('dark-theme');

    return () => {
      document.body.classList.remove('dark-theme');
    };
  }, []);

  const hasCategoriesSelected = selectedCategories && selectedCategories.length > 0;

  return (
    <div className="fair-interactive-map-filter-bar">
      <div className="container">
        <div className="row">
          <div className="col-12 fair-interactive-map-filter-bar-content">
            <div className="fair-interactive-map-filter-bar-filters">
              {!!renderFilterList && (
                <button
                  className="fair-interactive-map-filter-bar-filters-opener"
                  type="button"
                  onClick={handleSidebarOpen}
                >
                  <Settings />
                  Filters
                  {hasCategoriesSelected && (
                    <div className="fair-interactive-map-filter-bar-filters-number">
                      {selectedCategories.length}
                    </div>
                  )}
                </button>
              )}
              {renderFloorSelector}
              {hasCategoriesSelected && (
                <div className="fair-interactive-map-filter-bar-selected-filters">
                  {selectedCategories.map((category) => (
                    <button
                      key={category}
                      type="button"
                      data-category={category}
                      onClick={() => setValue(
                        'fairSections',
                        selectedCategories.filter((c) => c !== category),
                      )}
                    >
                      <span>{category}</span>
                    </button>
                  ))}
                  <button
                    className="fair-interactive-map-filter-bar-selected-filters-clear"
                    type="button"
                    onClick={clearValues}
                  >
                    <span>Delete all</span>
                  </button>
                </div>
              )}
            </div>
            {renderSearchBox && (
              <div className="fair-interactive-map-filter-bar-search">
                {renderSearchBox}
              </div>
            )}
          </div>
        </div>
      </div>
      {createPortal(
        <Slideout
          className="fair-interactive-map-filter-bar-filters-content"
          isOpen={isOpen}
          closeLabel={`Show results - ${numberOfResults || 0}`}
          backdropBehavior="close"
          onClose={handleSidebarClose}
        >
          <>
            <div className="fair-interactive-map-filter-bar-filters-content-title">Categories</div>
            {renderFilterList}
          </>
        </Slideout>,
        document.body,
      )}
    </div>
  );
}

export { FairInteractiveMapFilterBar };

FairInteractiveMapFilterBar.propTypes = {
  numberOfResults: PropTypes.number,
  selectedCategories: PropTypes.arrayOf(PropTypes.string),
  setValue: PropTypes.func.isRequired,
  clearValues: PropTypes.func.isRequired,
  renderFilterList: PropTypes.element,
  renderFloorSelector: PropTypes.element,
  renderSearchBox: PropTypes.element,
};

FairInteractiveMapFilterBar.defaultProps = {
  numberOfResults: null,
  selectedCategories: [],
  renderFilterList: null,
  renderFloorSelector: null,
  renderSearchBox: null,
};
